import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import { Rating } from "react-simple-star-rating";
import "./SubmitReview.css";
import SubmittedReview from "../SubmittedReview/SubmittedReview";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import BubbleSvgButton from "../../../../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const SubmitReview = () => {
  const [show, setShow] = useState(true);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [showSubmittedReview, setShowSubmittedReview] = useState(false);
  const handleClose = () => {
    navigate("/member/dashboard");
  };
  const handleShow = () => setShow(true);
  const api = useApi();
  const navigate = useNavigate();

  const handleRating = (rate) => {
    setRating(rate);
  };

  const callApi = async () => {
    // Validate both fields
    if (!rating && !comment) {
      toastify("Both rating and comment are required");
      return;
    } else if (!rating) {
      toastify("Rating is required");
      return;
    } else if (!comment.trim()) {
      toastify("Comment is required");
      return;
    }

    try {
      const response = await api("post", "communityReview/submitReview", {
        rating,
        comment,
      });

      if (response?.status) {
        setShowSubmittedReview(true);

        setTimeout(() => {
          navigate("/member/dashboard");

          setShowSubmittedReview(false);
          setComment("");
          setRating("");
        }, 2000);
      } else {
        setShowSubmittedReview(false);
        setComment("");
        setRating("");
        toastify(response?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-onboarding-modal cmSide reviewModal"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body className="figma-drop-shadow">
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="Cross Image" />
          </button>
          <div className="onboardingContentBox top31px">
            <h2 className="title">
              <span>Submit a review</span>
            </h2>
            <p className="desc">Please rate our service</p>
            <div className="mb45px">
              <Rating
                onClick={handleRating}
                initialValue={rating}
                fillColor="#11b700"
              />
            </div>
            <div className="formBox">
              <p className="label">Please leave a few words</p>
              <textarea
                name="review"
                id="review"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
              />

              <div>
                <BubbleSvgButton
                  onClick={callApi}
                  className="NextBtn"
                  text={"Submit Review"}
                  type="button"
                  variant="green"
                  containerStyling={{
                    justifyContent: "center",
                    padding: 0,
                  }}
                  mainDivStyle={{
                    width: "275px",
                    height: "55px",
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {showSubmittedReview && <SubmittedReview />}
    </div>
  );
};

export default SubmitReview;
